import { useState } from "react";
import { Mail, Check, Loader2 } from "lucide-react";
import { localApi } from "../lib/localApi";

/** Inscription newsletter du blog (`POST /public/newsletter`). Piège à robots : champ `website` caché. */
export function NewsletterForm({ source = "blog", compact = false }) {
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("loading"); setError("");
    try {
      const { data } = await localApi.post("/public/newsletter", { email: email.trim(), source, website });
      setState(data.already ? "already" : "done");
    } catch (err) {
      setError(err?.response?.data?.detail || "Inscription impossible, réessayez.");
      setState("idle");
    }
  };
  if (state === "done" || state === "already") {
    return (
      <div className="rounded-2xl border border-brass/40 bg-brass/10 p-5 flex items-start gap-3" data-testid="newsletter-success">
        <Check className="h-5 w-5 text-brass shrink-0 mt-0.5" />
        <p className="text-sm text-slate-200">{state === "already" ? "Vous êtes déjà inscrit(e) — merci !" : "C'est noté : vous recevrez chaque nouveau guide par e-mail. Un mail de bienvenue vient de partir."}</p>
      </div>
    );
  }
  return (
    <form onSubmit={submit} className={`rounded-2xl border border-white/10 bg-white/[0.04] ${compact ? "p-5" : "p-6 sm:p-8"}`} data-testid="newsletter-form">
      <p className="text-xs uppercase tracking-[0.2em] text-brass inline-flex items-center gap-2"><Mail className="h-3.5 w-3.5" /> Newsletter</p>
      <h3 className={`font-serif text-white mt-2 ${compact ? "text-xl" : "text-2xl"}`}>Recevez les prochains guides</h3>
      <p className="mt-1 text-sm text-slate-400">Un e-mail par guide publié, écrit pour les conciergeries. Zéro spam, désinscription en un clic.</p>
      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@votre-conciergerie.fr" autoComplete="email"
          className="flex-1 rounded-full bg-[#071e42] border border-white/15 px-4 py-2.5 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-brass" data-testid="newsletter-email" />
        <input type="text" value={website} onChange={(e) => setWebsite(e.target.value)} tabIndex={-1} autoComplete="off" className="hidden" aria-hidden="true" name="website" />
        <button type="submit" disabled={state === "loading"} className="rounded-full bg-brass text-[#071e42] font-medium px-5 py-2.5 text-sm hover:brightness-110 transition inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="newsletter-submit">
          {state === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : null} S'inscrire
        </button>
      </div>
      {error && <p className="mt-2 text-xs text-rose-300" data-testid="newsletter-error">{error}</p>}
    </form>
  );
}
